<template>
  <div class="toggle-switch m-b-20">
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <base-input-toggle-switch
      :id="id"
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <label :for="id" class="ts-label m-l-10">
      {{ label }}
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <base-info-tooltip v-if="helpInfo" :text="helpInfo" />
    </label>
  </div>
</template>

<script>
/**
 * Note: due to the hashing generation of id, these props can never be identical between usages
 */
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    helpInfo: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  computed: {
    id() {
      return btoa(JSON.stringify(this.$props))
    },
  },
}
</script>
